
  <!-- Sidebar navigation -->
  <mdb-side-nav #sidenav class="nav-bg fixed" [fixed]="true">
        <!-- Logo -->
        <div *ngIf="canShowHeader">
          <li class="position-relative">
            <div class="logo-icon"><mdb-icon fas icon="clipboard-list" class="m-0 fa-2x text-dark"></mdb-icon></div>
            <div class="logo-wrapper waves-dark">
              <div style="position: absolute;margin: 8px">
                <switch-app-dropdown *axLazyElement="switchAppDropDownCdnUrl" [getToken]="sendToken" [incoming]="dropDownSendData" ></switch-app-dropdown>
              </div>
              <a href="javascript:void(0)"><img src="assets/img/TruTesta/trutesta_icon.png" class="img-fluid flex-center"></a>
            </div>
          </li>
  
          <li>
            <ul class="collapsible collapsible-accordion">
              <mdb-accordion [multiple]="false" aria-multiselectable="false">
    
                <!-- Simple link -->
                <mdb-accordion-item class="no-collase">
                  <mdb-accordion-item-head routerLink="test-plans" routerLinkActive="active" mdbWavesEffect>
                    <mdb-icon fas icon="clipboard-list" class="mr-0 pr-2"></mdb-icon>{{ 'administration_testPlans_label' | translate }}
                  </mdb-accordion-item-head>
                  <mdb-accordion-item-body></mdb-accordion-item-body>
                </mdb-accordion-item>
  
    
              </mdb-accordion>
            </ul>
          </li>
        </div>
        <!--/. Side navigation links -->
        <div class="sidenav-bg mask-strong"></div>
      </mdb-side-nav>
    <!--/. Sidebar navigation -->
  
    <!-- Navbar -->
      <mdb-navbar SideClass="navbar navbar-expand-md scrolling-navbar double-nav" [containerInside]="false">
        <navlinks class="navbar-container">
            <!-- SideNav slide-out button -->
            <div class="float-xs-left" *ngIf="canShowHeader">
                <a (click)="sidenav.toggle()" class="button-collapse-non-fixed">
                    <mdb-icon fas icon="bars"></mdb-icon>
                </a>
            </div>
            <!--/. SideNav slide-out button -->
        </navlinks>
        <logo>
            <!-- Breadcrumb-->
            <div class="breadcrumbs breadcrumb-dn mr-auto">
              <p style="font-size:24px;color:#999" ><span style="font-family:'KeepCalm';color:#444">Tru</span><span style="font-family:'KeepCalm';color:#729bbc">TestPlans</span><sup style="font-size:60%">&trade;</sup></p>
            </div>
            <!--/. Breadcrumb-->
        </logo>
        <navlinks>
            <ul class="nav navbar-nav nav-flex-icons ml-auto ie-double-nav">
                <li class="nav-item" *ngIf="canShowHeader">
                  <upload-icon [sprigInfo]="defaultSprigInfo"></upload-icon>
                </li>
                <li class="nav-item" *ngIf="canShowHeader">
                  &nbsp;
                </li>
                <li class="nav-item dropdown btn-group" dropdown>
                    <a class="nav-link waves-light dropdown-toggle" mdbWavesEffect dropdownToggle type="button" >
                        <div class="people_avatar-container">
                            <span class="people_avatar">
                                <img ngxGravatar [email]="userEmailAddress" [size]="31" [fallback]="'blank'" />
                            </span>
                            <div class="people_fallbackInitial">{{loggedInUserInitials}}</div>
                        </div>
                      <span class="clearfix d-none d-sm-inline-block">{{user}}</span>
                    </a>
                    <div class="dropdown-menu dropdown-ins dropdown-menu-right" role="menu">
                        <refresh-document-service *ngIf="canShowHeader"></refresh-document-service>
                        <a *ngIf="canShowHeader" class="dropdown-item " href="javascript:void(0)" (click)=" openUserPreferencesModal()">
                          <mdb-icon fas icon="user-cog" class=" mr-1" style="font-size:1.1rem"></mdb-icon>
                          {{ 'header_userPreferences_label' | translate }}
                        </a>
                        <a class="dropdown-item " href="javascript:void(0)" (click)="logout()">{{ 'header_logout_label' | translate }}</a>
                    </div>
                </li>
                <li class="nav-item" (click)="toggleShowDrawer()" *ngIf="canShowHeader">
                  <a class="nav-link waves-light" mdbWavesEffect href="javascript:void(0)">
                      <mdb-icon fas icon="bell"></mdb-icon>
                      <div class="badge-count-label badge badge-danger" *ngIf="msgCount>0">{{msgCount}}</div>
                  </a>
                </li>
            </ul>
        </navlinks>
      </mdb-navbar>
    <!--/. Navbar -->
    
    <user-preferences-modal [endpoint]="endpoints" [endpoint]="endpoints"  [incoming]="userPreferencesData" (sprigInfoEmitter)="getSprigInfo($event)" (changedLanguage)="langChanged($event)"
(toastMessage)="toastMessages($event)"  *axLazyElement="userPreferenceCdnUrl" [getToken]="sendToken" >
</user-preferences-modal>

    <notify-card *axLazyElement="notificationCompCdnUrl" [(incoming)]="notificationInfo" (updateNotificationCount)="notificationCount()"
   (outgoing)="closeNotification($event)"></notify-card>

   <common-document-warning-modal [modalDetails]="sprigWarningData"></common-document-warning-modal>